export enum ENUM__generation_setting {
  /*
   * ML ASSETS
   */

  ML_ASSET_BUNDLE = 'ML_ASSET_BUNDLE',

  ML_ASSET_SAFETY_CHECKER = 'ML_ASSET_SAFETY_CHECKER',
  ML_ASSET_IMAGE_ENCODER = 'ML_ASSET_IMAGE_ENCODER',

  ML_ASSET_SCHEDULER_CONFIG = 'ML_ASSET_SCHEDULER_CONFIG', //could not be as dimension type, at least before split into params
  ML_ASSET_TOKENIZER = 'ML_ASSET_TOKENIZER', //could not be as dimension type

  ML_ASSET_TEXT_ENCODER = 'ML_ASSET_TEXT_ENCODER',
  ML_ASSET_VAE = 'ML_ASSET_VAE',
  ML_ASSET_UNET = 'ML_ASSET_UNET',

  ML_ASSET_IMAGE_PROCESSOR = 'ML_ASSET_IMAGE_PROCESSOR',

  /*
   * IMAGE
   */

  IMAGE_SIZE_MULTIPLIER = 'IMAGE_SIZE_MULTIPLIER', //could not be as dimension type
  IMAGE_SIZE_ASPECT_RATIO = 'IMAGE_SIZE_ASPECT_RATIO', //could not be as dimension type

  IMAGE_CANVAS_HASH_SHA256 = 'IMAGE_CANVAS_HASH_SHA256', //could not be as dimension type
  IMAGE_CANVAS_STRENGTH = 'IMAGE_CANVAS_STRENGTH', //todo: finish

  IMAGE_MASK_HASH_SHA256 = 'IMAGE_MASK_HASH_SHA256', //could not be as dimension type

  /*
   * IMAGE LINE GUIDANCE
   */
  IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_START = 'IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_START',
  IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_END = 'IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_END',
  IMAGE_LINE_GUIDANCE_CONTROL_NET_HASH_SHA256 = 'IMAGE_LINE_GUIDANCE_CONTROL_NET_HASH_SHA256',

  IMAGE_LINE_GUIDANCE_IMAGE_HASH_SHA256 = 'IMAGE_LINE_GUIDANCE_IMAGE_HASH_SHA256', //could not be as dimension type
  IMAGE_LINE_GUIDANCE_IMAGE_WEIGHT = 'IMAGE_LINE_GUIDANCE_IMAGE_WEIGHT',
  /*
   * IP ADAPTER
   */
  IP_ADAPTER_SCALE_DOWN = 'IP_ADAPTER_SCALE_DOWN',
  IP_ADAPTER_SCALE_MIDDLE = 'IP_ADAPTER_SCALE_MIDDLE',
  IP_ADAPTER_SCALE_UP = 'IP_ADAPTER_SCALE_UP',

  IP_ADAPTER_SCALES_ALL = 'IP_ADAPTER_SCALES_ALL',

  IP_ADAPTER_IMAGE_WEIGHT = 'IP_ADAPTER_IMAGE_WEIGHT',

  IP_ADAPTER_HASH = 'IP_ADAPTER_HASH', //could not be as dimension type

  /*
   * LORA
   */
  LORA_WEIGHT_MASTER = 'LORA_WEIGHT_MASTER',
  LORA_WEIGHT = 'LORA_WEIGHT',

  /*
   * TEXT
   */

  PROMPT = 'PROMPT', //could not be as dimension type

  TOKEN_WEIGHT = 'TOKEN_WEIGHT',

  CLIP_SKIP = 'CLIP_SKIP',

  /*
   * OTHER
   */
  GUIDANCE_SCALE = 'GUIDANCE_SCALE',
  GUIDANCE_RESCALE = 'GUIDANCE_RESCALE',

  INFERENCE_STEPS = 'INFERENCE_STEPS',

  SCHEDULER_TYPE = 'SCHEDULER_TYPE',
  SEED = 'SEED',
}
